import React, { useState } from "react";
import { ReactComponent as PlusIcon } from "../../../assets/previewPage/icons/Plus.svg";
import { ReactComponent as MinusIcon } from "../../../assets/previewPage/icons/minus.svg";

const FaqCard = ({ item, styles }) => {
  const [isOpen, setIsOpen] = useState(false);
  const coloum_value = JSON.parse(item?.coloum_value);
  const fonts = styles?.filter((item) => item.coloum_name === "fonts")?.[0];
  const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);
  return (
    <div
      className={`w-full bg-white rounded-lg md:rounded-[16px] select-none ${
        isOpen ? "py-[12px] md:py-[30px] px-[12px] md:px-[24px]" : "p-[12px] md:p-[24px]"
      }`}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer flex items-center justify-between select-none"
      >
        <div>
          <button style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3_b md:text-body_copy2_black capitalize text-heading_color font-${fontValue?.fontType?.value}`}>
            {coloum_value?.[0]?.title}
          </button>
        </div>
        <div>
        {isOpen ? <MinusIcon className="w-[12px] h-[12px] md:h-[20px] md:w-[20px]"/> : <PlusIcon className="w-[12px] h-[12px] md:h-[20px] md:w-[20px]" />}
        </div>
      </div>
      {isOpen && (
        <div className="pt-[20px] ">
          <p style={{ color: fontValue?.fontColor, fontFamily: fontValue?.fontType?.value }} className={`text-small3 md:text-body_copy2 text-body_copy_medium_color capitalize font-${fontValue?.fontType?.value}`}>
          {coloum_value?.[0]?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default FaqCard;
